let modalDiv: HTMLElement | null;

export const MODAL_DIV_ID = 'MiniModal';

/**
 * Adds a div for modal if not preset and returns it.
 */
export function getModalDiv(): HTMLElement | null {
    if (!modalDiv) {
        modalDiv = document.createElement('div');
        modalDiv.id = MODAL_DIV_ID;
        document.body.appendChild(modalDiv);
    }

    return modalDiv;
}

/**
 * Removes the modal div from dom
 */
export function purgeModalDiv() {
    if (modalDiv) {
        document.body.removeChild(modalDiv);
        modalDiv = null;
    }
}
